import { render, staticRenderFns } from "./Fullname.vue?vue&type=template&id=116dda11&scoped=true&"
import script from "./Fullname.vue?vue&type=script&lang=js&"
export * from "./Fullname.vue?vue&type=script&lang=js&"
import style0 from "./Fullname.vue?vue&type=style&index=0&id=116dda11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116dda11",
  null
  
)

export default component.exports